module.exports = __webpack_public_path__ + "static/media/linkedin.6e154f80.png";